export default "__VITE_ASSET__CLUdXyiZ__"